module.exports = __webpack_public_path__ + "static/media/rokko-karhuvaara.8361c5c7.jpg";